import initialState from './initialState';

export const GetCycleCountsReducer = {
  pending: (state) => ({
    ...state,
    list: [],
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data, totalRows } = action.payload;

    const updatedList = data.map((cycleCountItem) => {
      if (cycleCountItem.assignedUser && cycleCountItem.assignedUser.fullName) {
        return {
          ...cycleCountItem,
          assignedUser: cycleCountItem.assignedUser.fullName,
        };
      }

      return cycleCountItem;
    });
    return {
      ...state,
      list: updatedList || [],
      totalRows,
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    list: [],
    loading: 'failed',
  }),
};

export const GetCycleCountNumbersReducer = {
  pending: (state) => ({
    ...state,
    numberList: [],
    numberListLoading: 'pending',
  }),
  fulfilled: (state, action) => ({
    ...state,
    numberList: action.payload.data || [],
    numberListLoading: 'succeeded',
  }),
  rejected: (state) => ({
    ...state,
    numberList: [],
    numberListLoading: 'failed',
  }),
};

export const GetCycleCountByIdReducer = {
  pending: (state) => ({
    ...state,
    selectedItem: {
      ...state.selectedItem,
      loading: 'pending',
    },
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      selectedItem: {
        data,
        loading: 'succeeded',
      },
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    selectedItem: {
      ...state.selectedItem,
      loading: 'failed',
    },
    loading: 'failed',
  }),
};

export const UpdateCycleCountReducer = {
  pending: (state) => ({
    ...state,
    selectedItem: {
      ...state.selectedItem,
      loading: 'pending',
    },
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      selectedItem: {
        data,
        loading: 'succeeded',
      },
      list: state.list.map((item) => {
        if (item._id === data._id) {
          return data;
        }

        return item;
      }),
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    selectedItem: {
      ...state.selectedItem,
      loading: 'failed',
    },
    loading: 'failed',
  }),
};

export const ChangeCycleCountStatusReducer = {
  pending: (state) => ({
    ...state,
    selectedItem: {
      ...state.selectedItem,
      loading: 'pending',
    },
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      selectedItem: {
        data,
        loading: 'succeeded',
      },
      list: state.list.map((item) => {
        if (item._id === data._id) {
          return data;
        }

        return item;
      }),
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    selectedItem: {
      ...state.selectedItem,
      loading: 'failed',
    },
    loading: 'failed',
  }),
};

export const ClearSelectedCycleCountReducer = (state) => ({
  ...state,
  selectedItem: {
    data: null,
    loading: 'idle',
  },
});

export const GetCycleCountResultByIdReducer = {
  pending: (state) => ({
    ...state,
    result: {
      ...state.result,
      loading: 'pending',
    },
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      result: {
        data,
        loading: 'succeeded',
      },
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    result: {
      ...state.result,
      loading: 'failed',
    },
    loading: 'failed',
  }),
};

export const GetPendingCycleCountRequestsReducer = {
  pending: (state) => ({
    ...state,
    pending: {
      ...state.pending,
      loading: 'pending',
    },
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      pending: {
        data,
        loading: 'succeeded',
      },
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    pending: {
      ...state.pending,
      loading: 'failed',
    },
    loading: 'failed',
  }),
};

export const UpdateCycleCountResultReducer = {
  pending: (state) => ({
    ...state,
    result: {
      ...state.result,
      loading: 'pending',
    },
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data: updatedItem } = action.payload;

    return {
      ...state,
      result: {
        data: state.result.data.map((item) => (item._id === updatedItem._id ? updatedItem : item)),
        loading: 'succeeded',
      },
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    result: {
      ...state.result,
      loading: 'failed',
    },
    loading: 'failed',
  }),
};

export const FactoryOptionsTobaccoTypesReducer = {
  pending: (state) => ({
    ...state,
    tobaccoTypes: {
      ...state.tobaccoTypes,
      loading: 'pending',
    },
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      tobaccoTypes: {
        data,
        loading: 'succeeded',
      },
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    tobaccoTypes: {
      ...state.tobaccoTypes,
      loading: 'failed',
    },
    loading: 'failed',
  }),
};

export const GetConveyorStepsReducer = {
  pending: (state) => ({
    ...state,
    conveyorSteps: {
      ...state.conveyorSteps,
      loading: 'pending',
    },
    loading: 'pending',
  }),
  fulfilled: (state, action) => {
    const { data } = action.payload;

    return {
      ...state,
      conveyorSteps: {
        data: data.list,
        loading: 'succeeded',
      },
      loading: 'succeeded',
    };
  },
  rejected: (state) => ({
    ...state,
    conveyorSteps: {
      ...state.conveyorSteps,
      loading: 'failed',
    },
    loading: 'failed',
  }),
};

export const ApplyActualQuantityReducer = {
  pending: (state) => ({
    ...state,
  }),
  fulfilled: (state, action) => ({
    ...state,
    result: {
      ...state.result,
      data: state.result?.data.map((item) => (item._id === action.payload.data._id ? action.payload.data : item)) || [
        action.payload.data,
      ],
    },
    loading: 'succeeded',
  }),
  rejected: (state) => ({
    ...state,
    loading: 'failed',
  }),
};

export const BatchApplyActualQuantityReducer = {
  pending: (state) => ({
    ...state,
    loading: 'pending',
  }),
  fulfilled: (state) => ({
    ...state,
    loading: 'succeeded',
  }),
  rejected: (state) => ({
    ...state,
    loading: 'failed',
  }),
};

export const ResetCycleCountStateReducer = () => initialState;
